import * as React from 'react';

import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';

import { apiClient, useRealtimeChannel } from '../../state';

/**
 * Return action and state of the AI search for an organization.
 */
export function useConfigureAISearch(organization: api.Organization) {
    const [ready, setReady] = React.useState(!!organization.ai);

    useRealtimeChannel(
        {
            channel: 'organization-ai-indexation',
            organization: organization.id,
        },
        () => {
            // As soon as we receive the first message, we consider the organization as ready
            setReady(true);
        }
    );

    const enable = React.useCallback(
        async (from: 'settings' | 'search') => {
            await apiClient.organizations.updateOrganizationById(organization.id, {
                ai: true,
            });

            analytics.logEvent(
                analytics.createOrgEvent(organization, {
                    type: 'organization_enable_ai',
                    from,
                })
            );
        },
        [organization.id]
    );

    const disable = React.useCallback(async () => {
        await apiClient.organizations.updateOrganizationById(organization.id, {
            ai: false,
        });

        analytics.logEvent(
            analytics.createOrgEvent(organization, {
                type: 'organization_disable_ai',
            })
        );
    }, [organization.id]);

    return {
        enabled: !!organization.ai,
        ready,
        enable,
        disable,
    };
}
